import get from 'lodash.get';
import { emptyArray } from '../../../default-props/empty';

export const selectSearchResults = (state) => get(state, 'searchResults', emptyArray);
